import { CmsRegion } from '../../types/travelInsurance';

/**
 * CMS-1872: restrict the Annual region selector to the regions a component
 * marks visible. An empty or absent list keeps the full region set, so markets
 * without the config (e.g. SingSaver) are unaffected; once a list is
 * configured, anything not on it - including regions added later - is hidden.
 * Entries with an empty value cannot match anything and are dropped, so a list
 * of only degenerate entries also counts as "not configured" - the same
 * semantics normalizeTravelParams applies when resetting a hidden selection.
 */
export function filterAnnualVisibleRegions(
  regions: CmsRegion[],
  annualVisibleRegions: CmsRegion[] | undefined,
): CmsRegion[] {
  const allowedValues = annualVisibleRegions
    ?.map((region) => region.value)
    .filter(Boolean);
  if (!allowedValues?.length) {
    return regions;
  }
  const allowed = new Set(allowedValues);
  return regions.filter((region) => allowed.has(region.value));
}
